import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["status", "guests", "guestNames"]

    connect() {
        this.sync()
    }

    statusChanged() {
        this.sync()
    }

    sync() {
        if (!this.hasStatusTarget || !this.hasGuestsTarget) return

        const status = this.statusTarget.value

        if (status === "DECLINED") {
            this.guestsTarget.value = 0
            this.guestsTarget.min = 0
            this.guestsTarget.disabled = true
            this.guestsTarget.required = false

            if (this.hasGuestNamesTarget) {
                // Important: do NOT clear guest names.
                // Keep the value in the field so it comes back if host switches to Attending.
                this.guestNamesTarget.disabled = true
                this.guestNamesTarget.required = false
            }
        } else {
            this.guestsTarget.disabled = false
            this.guestsTarget.required = true
            this.guestsTarget.min = 1

            if (!this.guestsTarget.value || parseInt(this.guestsTarget.value, 10) < 1) {
                this.guestsTarget.value = 1
            }

            if (this.hasGuestNamesTarget) {
                this.guestNamesTarget.disabled = false
                this.guestNamesTarget.required = true
            }
        }
    }
}